import { useIntl } from 'react-intl'
import Image from 'components/Common/Image/Image'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageContainer = styled.div`
  position: relative;
  min-height: ${rem(125)};
  min-width: ${rem(330)};
  width: 100%;
  aspect-ratio: 672 / 250;
  overflow: hidden;
`

const LogoOverlay = styled.div`
  position: absolute;
  top: ${rem(12)};
  right: ${rem(12)};
  width: 30%;
  height: 20%;
`

function WineSelectorsBackground() {
  const intl = useIntl()

  return (
    <ImageContainer>
      <Image
        image={{ id: 'wine-selectors-background' }}
        fit="center"
        objectFit="cover"
        alt={intl.formatMessage({
          id: '8RuyQjkijA2A4UjsA3yH',
          defaultMessage: 'Wine Selectors background image',
          description: 'Alternative text for the Wine Selectors background image in the partner promotion modal',
        })}
      />
      <LogoOverlay>
        <Image
          image={{ id: 'wine-selectors-logo-inverse' }}
          fit="center"
          objectFit="contain"
          alt={intl.formatMessage({
            id: '0J_qAScBfL8xAR1ccGr2',
            defaultMessage: 'Wine Selectors logo',
            description: 'Alternative text for the Wine Selectors logo in the partner promotion modal',
          })}
        />
      </LogoOverlay>
    </ImageContainer>
  )
}

export default WineSelectorsBackground
